import connection from './connection.js'

const list = async function (callback) {
  const url = '/admin/merchant/list'
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const getPullStoreList = async function (callback) {
  const url = '/admin/store/list'
  let {
    error,
    data
  } = await connection.query(url)
  if (callback) callback(error, data)
}

const lists = async function (page, keyword, callback) {
  const url = '/admin/merchant/lists'
  let {
    error,
    data
  } = await connection.query(url, {
    page: page,
    keyword: keyword
  })
  if (callback) callback(error, data)
}

const create = async function (params, callback) {
  const url = '/admin/merchant/create'
  let {
    error,
    data
  } = await connection.update(url, params)
  if (callback) callback(error, data)
}


export default {
  list: list,
  lists: lists,
  create: create,
  getPullStoreList: getPullStoreList
}
